export default {
  computed: {
    interfaceValue: {
      get() {
        if (this.question.multiSelect && this.question.multiSelect === true) {
          return Array.isArray(this.fieldValue) ? this.fieldValue : [];
        }

        return this.fieldValue;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
};
